export const isOptionSelected = (currentPath, optionLink = '') => {
  const regexPattern = currentPath === '/' ? '^/$' : `^/${currentPath?.split('/')[1]}`

  return new RegExp(regexPattern).test(optionLink)
}
